import { Position } from '@cutr/constants/windows/windows';
import Konva from 'konva';
import { create } from 'zustand';

interface StageRefsStore {
  stageRefsMap: Map<string, React.RefObject<Konva.Stage>>;
  registerStageRef: (
    positionId: string,
    stageRef: React.RefObject<Konva.Stage>
  ) => void;
  unregisterStageRef: (positionId: string) => void;
}

export const useStageRefs = create<StageRefsStore>((set) => ({
  stageRefsMap: new Map(),
  registerStageRef: (
    positionId: string,
    stageRef: React.RefObject<Konva.Stage>
  ) => {
    set((state) => {
      const newMap = new Map(state.stageRefsMap);
      newMap.set(positionId, stageRef);
      return { stageRefsMap: newMap };
    });
  },
  unregisterStageRef: (positionId: string) => {
    set((state) => {
      const newMap = new Map(state.stageRefsMap);
      newMap.delete(positionId);
      return { stageRefsMap: newMap };
    });
  },
}));

export const usePositionImages = (positions: Position[]) => {
  const { stageRefsMap } = useStageRefs();

  const exportImages = () => {
    const images: Record<Position['id'], string> = {};
    for (const position of positions) {
      const stageRef = stageRefsMap.get(position.id);

      if (!stageRef?.current) {
        console.error(`Stage ref not found for position ${position.id}`);
        continue;
      }

      const stage = stageRef.current;

      const image = stage.toDataURL({
        pixelRatio: 2,
      });
      images[position.id] = image;
    }
    return images;
  };

  return exportImages;
};
